module.exports = __webpack_public_path__ + "img/meuble2.62268b13.png";